import { guestOrderSelector } from "ducks/selectors";
import { createSelector } from "reselect";

export const selectKoreUserData = createSelector(guestOrderSelector, order => {
  const {
    selected_number: mobileNumber,
    service_instance_number: siNumber,
    order_user_detail
  } = order || {};
  const { email, first_name: name } = order_user_detail || {};
  const koreUserData = email
    ? {
        name,
        email,
        mobileNumber,
        siNumber
      }
    : undefined;
  return koreUserData;
});

export const makeSelectKoreUserData = () => selectKoreUserData;
